export default __webpack_public_path__ + "static/media/click2.5b5930c4.wav";